<label
  [ngClass]="classes"
>
  <ng-content></ng-content>
  <span class="slider"></span>
</label>
